import { Alert, Text } from 'bold-ui'

export const HistoricoAtendimentoObservacaoAlert = () => {
  return (
    <Alert type='info' inline>
      <Text color='primary'>Cidadã(o) ficou em observação</Text>
    </Alert>
  )
}
